import { render } from "./ViewComposeInvitation.vue?vue&type=template&id=578cae4d&scoped=true"
import script from "./ViewComposeInvitation.vue?vue&type=script&lang=js"
export * from "./ViewComposeInvitation.vue?vue&type=script&lang=js"

import "./ViewComposeInvitation.vue?vue&type=style&index=0&id=578cae4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578cae4d"]])

export default __exports__